import React from 'react'
import { Button, Col, Modal, Row } from 'antd'
import PayrollClaimCSVForm from '../../../../../components/People/PayrollClaim/AddPayrollClaim/Lines/PayrollClaimCSVForm'

function PayrollClaimCSVModal (props) {
  const { visibleCSV, formRefCSV, fetchingCSV, fetchCSV, onCancelCSV } = props
  return (
    <Modal
      visible={visibleCSV}
      title={'CSV'}
      onCancel={onCancelCSV}
      destroyOnClose={true}
      footer={
        <Row>
          <Col span={24} style={{ textAlign: 'right' }}>
            <Button loading={fetchingCSV} type="dashed" onClick={fetchCSV}>
              {'Get CSV'}
            </Button>
          </Col>
        </Row>
      }
      width={'75%'}>
      <PayrollClaimCSVForm ref={formRefCSV} {...props} />
    </Modal>
  )
}

PayrollClaimCSVModal.propTypes = {}
PayrollClaimCSVModal.defaultProps = {}

export default PayrollClaimCSVModal
